/******************************************************************************************
 *	Resellers Service
 ********************************************************************************************/
(function() {
  

  angular.module('rcServices.resellers', []).service(
    'Resellers',
    /* @ngInject */
    function(jilResellers) {
      this.invite = function(payload) {
        return jilResellers.resellers.save({}, payload).$promise;
      };
    }
  );
})();
